const getMiniProgramDataCSR = (): { clientId: string; sessionId: string } | undefined => {
  if (__CLIENT__) {
    const clientId = localStorage.getItem("clientId") || "";
    const sessionId = localStorage.getItem("sessionId") || "";
    if (clientId && sessionId) {
      return { clientId, sessionId };
    }
  }
  return {
    clientId: "",
    sessionId: "",
  };
};

export default getMiniProgramDataCSR;
